import UserGroupUpdateModal from "./UserGroupUpdateModal"

export default UserGroupUpdateModal
